import {
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import { Face } from "@material-ui/icons";
import CancelIcon from "@material-ui/icons/Cancel";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { getInputDateFormats } from "../../../utils/get-date-time-locale";

import { addHours, parseISO } from "date-fns";
import { findIndex, forEach, isEmpty, uniqueId } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import { useCommittees } from "../../../hooks/useCommittees";
import { useFormCombos } from "../../../hooks/useFormCombos";
import { useMeeting } from "../../../hooks/useMeeting";
import { actionShowSpinner } from "../../../redux-flow/action/Wrapper/Spinner";
import { getMembersByCommitteeId as getCommitteeMembers } from "../../../services/members.service";

import { MdGroups } from "react-icons/md";
import {
  getMembersById,
  getMembersByName,
} from "../../../services/formCombos.service.js";
import {
  cancelMeetingById,
  deleteMeetingById,
  updateMeeting,
} from "../../../services/meeting.service";
import DialogCustom from "../../Common/DialogCustom";
import { Select } from "../../Common/Select";
import ToastMessage from "../../Common/ToastMessage";
import { checkAccess } from "../utils/index";
import { Circle, WrapperChip } from "./styles.js";

const DAYSOFWEEKDEFAULT = [
  { id: 1, name: "monday" },
  { id: 2, name: "tuesday" },
  { id: 3, name: "wednesday" },
  { id: 4, name: "thursday" },
  { id: 5, name: "friday" },
  { id: 6, name: "saturday" },
  { id: 0, name: "sunday" },
];

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  paper: {
    padding: 40,
    marginBottom: 40,
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20,
  },
  cancelIcon: {
    color: theme.palette.error.main,
  },
  iconText: {
    ...theme.typography.subtitle1,
    cursor: "pointer",
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  buttonOutlined: {
    ...theme.typography.subtitle1,
    border: "2px solid",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20,
  },
}));

const FormMeetingEdit = ({ t, i18n, match, history, actionShowSpinner }) => {
  const classes = useStyles();
  const { userAccess } = useAuth();

  const {
    params: { id },
  } = match;

  const {
    getMembers,
    membersList,
    getFrequencyMeeting,
    frequencyMeeting,
    days,
    getDays,
    getEndAfter,
    endAfter,
    membersParticipantsList,
    getMembersByCommitteeId,
    ordinalNumber,
    getOrdinalNumber,
    getMonths,
    months,
  } = useFormCombos();

  const { getCommitteesByLanguageId, committeesListSelect } = useCommittees({
    spinner: actionShowSpinner,
  });

  const { getMeetingById, meeting } = useMeeting({
    spinner: actionShowSpinner,
  });

  const [value, setValue] = useState({
    frequencyMonth: "frequencyDayOfMonths",
    frequencyYear: "periodMonths",
    recurrence: false,
    roundRobin: false,
    onlineMeet: true,
  });
  const [toastMessage, setToastMessage] = useState({
    message: "",
    type: "error",
    open: false,
  });
  const [membersAllParticipantsList, setMembersAllParticipantsList] = useState(
    []
  );
  const [memberName, setMemberName] = useState([]);

  const [
    membersAllParticipantsListSelected,
    setMembersAllParticipantsListSelected,
  ] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());

  const [programEndDay, setProgramEndDay] = useState(false);
  const [selectedDaysWeeklyFrequency, setSelectedDaysWeeklyFrequency] =
    useState([]);

  const [canCancelMeet, setCanCancelMeet] = useState(false);
  const [canDeleteMeet, setCanDeleteMeet] = useState(false);
  const [canUpdateMeet, setCanUpdateMeet] = useState(false);
  const [canShowMeet, setCanShowMeet] = useState(false);
  const [detailMeet, setDetailMeet] = useState(false);

  useEffect(() => {
    if (userAccess) {
      const hasAccessToCancelMeet = checkAccess(userAccess, "cancelMeet");
      const hasAccessToDeleteMeet = checkAccess(userAccess, "deleteMeet");
      const hasAccessToUpdateMeet = checkAccess(userAccess, "updateMeet");
      const hasAccessToShowMeet = checkAccess(userAccess, "lookupMeet");

      setCanCancelMeet(hasAccessToCancelMeet);
      setCanDeleteMeet(hasAccessToDeleteMeet);
      setCanUpdateMeet(hasAccessToUpdateMeet);
      setCanShowMeet(hasAccessToShowMeet);

      if (
        !hasAccessToCancelMeet &&
        !hasAccessToDeleteMeet &&
        !hasAccessToUpdateMeet &&
        !hasAccessToShowMeet
      ) {
        history.push("/");
      }

      if (i18n.language) {
        getMembers(i18n.language);
        getMonths(i18n.language);
        getCommitteesByLanguageId(i18n.language);
        getFrequencyMeeting(i18n.language);
        getDays(i18n.language);
        getEndAfter(i18n.language);
        getOrdinalNumber(i18n.language);
      }
    }
  }, [i18n.language, userAccess]);

  useEffect(() => {
    setDetailMeet(history?.location?.state?.detailMeet);
  }, [history]);

  useEffect(() => {
    setMembersAllParticipantsList(membersList);
  }, [membersList]);

  useEffect(() => {
    if (id) getMeetingById(id);
  }, [id]);

  useEffect(() => {
    if (!isEmpty(value.committee)) {
      getMembersByCommitteeId(i18n.language, value.committee);
    }
  }, [value.committee, i18n.language]);

  const findDaysList = (dayId) => findIndex(days, ["id", dayId]);
  const findEndAfterList = (endProgramId) =>
    findIndex(endAfter, ["id", endProgramId]);

  const fillMeeting = async (item) => {
    actionShowSpinner(true);

    const frequencyId = frequencyMeeting.find(
      (s) => s.id === item.scheduleMeetInput?.frequencyId
    );
    const dayId = findDaysList(item.daysOfWeek);
    const endProgramId = findEndAfterList(
      item.scheduleMeetInput.numberOfOccurrences
    );
    const newMonthSelected = months?.find(
      (month) =>
        month.id ===
        item.scheduleMeetInput?.kindOfFrequencyJson?.periodYearMonth
    );

    let formattedPeriodYearsDay = "";

    switch (
      item?.scheduleMeetInput?.kindOfFrequencyJson?.scheduleMeetYearFromWeekDay
        ?.indexWeekDay
    ) {
      case 7:
        formattedPeriodYearsDay = "sunday";
        break;
      case 1:
        formattedPeriodYearsDay = "monday";
        break;
      case 2:
        formattedPeriodYearsDay = "tuesday";
        break;
      case 3:
        formattedPeriodYearsDay = "wednesday";
        break;
      case 4:
        formattedPeriodYearsDay = "thursday";
        break;
      case 5:
        formattedPeriodYearsDay = "friday";
        break;
      case 6:
        formattedPeriodYearsDay = "saturday";
    }

    let formattedFrequencyIntervalDay = "";

    switch (
      item?.scheduleMeetInput?.kindOfFrequencyJson?.scheduleMeetMonthFromWeekDay
        ?.intervalFirstDayOfWeek
    ) {
      case 7:
        formattedFrequencyIntervalDay = "sunday";
        break;
      case 1:
        formattedFrequencyIntervalDay = "monday";
        break;
      case 2:
        formattedFrequencyIntervalDay = "tuesday";
        break;
      case 3:
        formattedFrequencyIntervalDay = "wednesday";
        break;
      case 4:
        formattedFrequencyIntervalDay = "thursday";
        break;
      case 5:
        formattedFrequencyIntervalDay = "friday";
        break;
      case 6:
        formattedFrequencyIntervalDay = "saturday";
    }

    const { data: secretary } = await getMembersById("pt", item.secretary.id);

    setValue({
      committee: committeesListSelect.find((s) => s.id === item.committee.id),
      secretary,
      subject: item.scheduleMeetInput.subject,
      place: item.scheduleMeetInput.locationName,
      startTime: item.scheduleMeetInput.meetStartTime,
      roundRobin: item.roundRobin,
      onlineMeet: item.scheduleMeetInput.onlineMeetingProvider,
      endTime: item.scheduleMeetInput.meetEndTime,
      comments: item.scheduleMeetInput.observation,
      recurrence: item.scheduleMeetInput.isRecurrence,
      frequency: frequencyId !== -1 ? frequencyId : {},
      dayOfMonth:
        item.scheduleMeetInput?.kindOfFrequencyJson?.scheduleMeetMonthFromDay
          ?.dayOfMonth,
      intervalMonth:
        item.scheduleMeetInput?.kindOfFrequencyJson?.scheduleMeetMonthFromDay
          ?.monthSpecificInterval,
      qtdMonths:
        item?.scheduleMeetInput?.kindOfFrequencyJson
          ?.scheduleMeetMonthFromWeekDay?.monthSpecificInterval,
      periodYearsOrdinalNumber: ordinalNumber.find(
        (number) =>
          number.id ===
          item?.scheduleMeetInput?.kindOfFrequencyJson
            ?.scheduleMeetYearFromWeekDay?.indexWeekDay
      ),
      ordinalNumber: ordinalNumber.find(
        (option) =>
          option.id ===
          item?.scheduleMeetInput?.kindOfFrequencyJson
            ?.scheduleMeetMonthFromWeekDay?.indexWeekDay
      ),
      frequencyIntervalDay: days.find(
        (day) => day.id === formattedFrequencyIntervalDay
      ),
      periodYearsDay: days.find((day) => day.id === formattedPeriodYearsDay),
      frequencyMonth:
        item.scheduleMeetInput?.kindOfFrequencyJson?.kindScheduleMeetMonth ===
        "D"
          ? "frequencyDayOfMonths"
          : "frequencyIntervalOfMonths",
      frequencyYear: item.scheduleMeetInput?.kindOfFrequencyJson?.periodMonths
        ? "periodMonths"
        : "periodYears",
      allDays:
        item.scheduleMeetInput?.kindOfFrequencyJson?.kindScheduleMeetDay === "A"
          ? true
          : false,
      intervalYear:
        item.scheduleMeetInput?.kindOfFrequencyJson?.yearSpecificInterval,
      periodMonthsCount:
        item.scheduleMeetInput?.kindOfFrequencyJson?.periodMonths,
      periodYearMonthSelected: newMonthSelected,
      daysOfWeek: dayId !== -1 ? days[dayId] : {},
      interval:
        item?.scheduleMeetInput?.kindOfFrequencyJson?.dailySpecificInterval,
      intervalWeek:
        item?.scheduleMeetInput?.kindOfFrequencyJson?.weekSpecificInterval,
      endProgram: endAfter.find((it) => it.id === endProgramId),
      startDate: item?.scheduleMeetInput?.meetStartDate,
      endDate: item?.scheduleMeetInput?.clousureDate,
    });

    if (item.scheduleMeetInput?.kindOfFrequencyJson?.daysOfWeek) {
      setSelectedDaysWeeklyFrequency(
        item.scheduleMeetInput?.kindOfFrequencyJson?.daysOfWeek
      );
    }

    setSelectedStartDate(item?.scheduleMeetInput?.meetStartDate);
    setSelectedEndDate(item?.scheduleMeetInput?.clousureDate);

    setProgramEndDay(item.scheduleMeetInput.numberOfOccurrences !== null);

    setSelectedDate(addHours(parseISO(item.scheduleMeetInput.meetDate), 6));
    setMembersAllParticipantsListSelected(item.scheduleMeetInput.attendees);

    actionShowSpinner(false);
  };

  useEffect(() => {
    if (
      !isEmpty(meeting) &&
      committeesListSelect?.length > 0 &&
      membersList?.length > 0 &&
      frequencyMeeting?.length > 0 &&
      days?.length > 0 &&
      endAfter?.length > 0
    ) {
      fillMeeting(meeting);
    }
  }, [
    meeting,
    committeesListSelect,
    membersList,
    frequencyMeeting,
    days,
    endAfter,
  ]);

  useEffect(() => {
    if (!isEmpty(value.participants)) {
      const membersAllParticipantsListSelectedNew = [
        ...membersAllParticipantsListSelected,
      ];
      membersAllParticipantsListSelectedNew.push(value.participants);

      const membersAllParticipantsListNew = [...membersAllParticipantsList];
      const idx = findIndex(membersAllParticipantsListNew, [
        "id",
        value.participants.id,
      ]);
      membersAllParticipantsListNew.splice(idx, 1);
      setMembersAllParticipantsList(membersAllParticipantsListNew);
      setValue({ ...value, participants: {} });
    }
  }, [value.participants]);

  useEffect(() => {
    if (membersParticipantsList?.length > 0) {
      const membersAllParticipantsListNew = [...membersAllParticipantsList];
      forEach(membersParticipantsList, (itens) => {
        const idx = findIndex(membersAllParticipantsListNew, ["id", itens.id]);
        membersAllParticipantsListNew.splice(idx, 1);
      });
      setMembersAllParticipantsList(membersAllParticipantsListNew);
    }
  }, [membersParticipantsList]);

  const handleChange = (event) => {
    setValue({ ...value, [event.target.name]: event.target.value });
  };

  const handleChangeInterval = (event) => {
    setValue({
      ...value,
      [event.target.name]: event.target.value,
      allDays: false,
    });
  };

  const handleChangeCheckbox = (event) => {
    setValue({
      ...value,
      [event.target.name]: event.target.checked,
      interval: event.target.checked ? "" : value.interval,
    });
  };

  const manageCommitteeMembers = async (committee) => {
    const attendeesWithoutCommitteeMembers =
      membersAllParticipantsListSelected.filter((member) => {
        return !member.hasOwnProperty("isCommitteeMember");
      });

    if (!committee) {
      setMembersAllParticipantsListSelected(attendeesWithoutCommitteeMembers);
      return;
    }

    const committeeId = committee.id;
    try {
      const committeeMembers = (await getCommitteeMembers(committeeId)) || [];

      const committeeMembersFormatted = committeeMembers
        .filter(
          (member) =>
            !membersAllParticipantsListSelected.some(
              (selectedMember) => selectedMember.id === member.idMember
            )
        )
        .map((member) => ({
          id: member.idMember,
          name: member.memberName,
          email: member.memberEmail,
          isCommitteeMember: true,
        }));

      setMembersAllParticipantsListSelected([
        ...attendeesWithoutCommitteeMembers,
        ...committeeMembersFormatted,
      ]);
    } catch (error) {
      setToastMessage({
        open: true,
        content: t("meeting.getCommitteeMembersError"),
        type: "error",
      });
    }
  };

  const handleChangeSelect = (selected, name) => {
    setValue({ ...value, [name]: selected });
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
  };

  useEffect(() => {
    value.secretary && setSecretary(value.secretary);
  }, [value]);

  const validateForm = () => {
    let errors = [];

    if (!value.committee || !value.committee.id || !value.committee.name) {
      errors.push("O campo de 'comitê' é obrigatório.");
    }

    if (!value.secretary || !value.secretary.id || !value.secretary.name) {
      errors.push("O campo de 'secretário' é obrigatório.");
    }

    if (!value?.startTime && !value.roundRobin) {
      errors.push("O campo de 'horário de início' é obrigatório.");
    }

    if (!value?.endTime && !value.roundRobin) {
      errors.push("O campo de 'horário de término' é obrigatório.");
    }

    if (value.recurrence && !value?.frequency?.name) {
      errors.push("O campo de 'frequência' é obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Diário" &&
      !value.interval &&
      !value.allDays
    ) {
      errors.push("Intervalo de tempo em dias obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Semanal" &&
      !value.intervalWeek
    ) {
      errors.push("Intervalo de tempo em semanas obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Semanal" &&
      selectedDaysWeeklyFrequency.length < 1
    ) {
      errors.push("Selecione ao menos um dia da semana.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyDayOfMonths" &&
      !value?.dayOfMonth
    ) {
      errors.push("Dia do mês obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyDayOfMonths" &&
      !value.intervalMonth
    ) {
      errors.push("Intervalo obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyIntervalOfMonths" &&
      !value.ordinalNumber
    ) {
      errors.push("Ordem obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyIntervalOfMonths" &&
      !value.frequencyIntervalDay
    ) {
      errors.push("Dia da semana obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyIntervalOfMonths" &&
      !value.qtdMonths
    ) {
      errors.push("Quantidade de meses obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      !value.periodYearMonthSelected
    ) {
      errors.push("Intervalo de tempo em anos obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      !value.periodYearMonthSelected
    ) {
      errors.push("Campo 'Mês' obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      value.frequencyYear === "periodMonths" &&
      !value.periodMonthsCount
    ) {
      errors.push("Quantidade de dias obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      value.frequencyYear === "periodYears" &&
      !value.periodYearsOrdinalNumber
    ) {
      errors.push("Campo 'Ordem' obrigatório.");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      value.frequencyYear === "periodYears" &&
      !value.periodYearsDay
    ) {
      errors.push("Dia da semana obrigatório.");
    }

    if (value.recurrence && programEndDay && !value.endProgram) {
      errors.push("Programar encerramento obrigatório.");
    }

    if (value.recurrence && !selectedStartDate) {
      errors.push("Campo de data de início obrigatório.");
    }

    if (value.recurrence && !selectedEndDate && !programEndDay) {
      errors.push("Campo de data de término obrigatório.");
    }

    return errors;
  };

  const handleSave = async () => {
    const errors = validateForm();
    actionShowSpinner(true);

    if (errors.length > 0) {
      setToastMessage({
        open: true,
        message: errors,
        type: "error",
      });

      actionShowSpinner(false);
      return;
    }

    let frequencyYear = "";

    if (value?.frequencyYear === "periodYears") {
      frequencyYear = "W";
    }
    if (value?.frequencyYear === "periodMonths") {
      frequencyYear = "Y";
    }

    let frequencyMonth = "";

    if (value.frequencyMonth === "frequencyDayOfMonths") {
      frequencyMonth = "D";
    }

    if (value.frequencyMonth === "frequencyIntervalOfMonths") {
      frequencyMonth = "W";
    }

    const getDayIndex = (day) => {
      let index;
      switch (day) {
        case "sunday":
          index = 7;
          break;
        case "monday":
          index = 1;
          break;
        case "tuesday":
          index = 2;
          break;
        case "wednesday":
          index = 3;
          break;
        case "thursday":
          index = 4;
          break;
        case "friday":
          index = 5;
          break;
        case "saturday":
          index = 6;
      }

      return index;
    };

    const request = {
      roundRobin: value.roundRobin,
      committee: {
        id: value?.committee && value?.committee?.id,
        name: value?.committee && value?.committee?.name,
      },
      secretary: {
        id: value?.secretary && value?.secretary?.id,
        name: value?.secretary && value?.secretary?.name,
        email: value?.secretary && value?.secretary?.email,
      },
      scheduleMeetInput: {
        timeZoneId: "E. South America Standard Time",
        subject: value.subject,
        locationName: value.place,
        onlineMeetingProvider: value.onlineMeet,
        meetDate: moment(selectedDate).format("YYYY-MM-DD"),
        MeetStartDate: selectedStartDate,
        ...(!programEndDay && { ClousureDate: selectedEndDate }),
        meetStartTime: value?.startTime,
        MeetEndTime: value?.endTime,
        isRecurrence: value?.recurrence,
        observation: value?.comments,
        ...(value.recurrence && {
          kindOfFrequencyJson: {
            ...(value?.interval && {
              DailySpecificInterval: Number(value?.interval),
            }),
            ...(value?.frequency?.id &&
              value?.frequency?.id === "D" && {
                KindScheduleMeetDay:
                  value?.interval > 0 && value?.frequency?.id === "D"
                    ? "I"
                    : "A",
              }),
            ...(frequencyYear.length > 0 &&
              value?.frequency?.id === "A" && {
                kindScheduleMeetYear: frequencyYear,
              }),
            ...(frequencyMonth.length > 0 &&
              value?.frequency?.id === "M" && {
                kindScheduleMeetMonth: frequencyMonth,
              }),
            ...(value?.intervalYear && {
              yearSpecificInterval: value?.intervalYear,
            }),
            ...(value?.intervalWeek && {
              weekSpecificInterval: value?.intervalWeek,
            }),
            ...(value?.periodMonthsCount &&
              value.frequency.id === "A" &&
              value.frequencyYear === "periodMonths" && {
                periodMonths: value?.periodMonthsCount,
              }),
            ...(value?.periodYearMonthSelected?.id && {
              periodYearMonth: value?.periodYearMonthSelected?.id,
            }),
            ...(value?.endProgram?.id &&
              programEndDay && {
                numberOfOccurrences:
                  value?.endProgram?.id !== 0 ? value?.endProgram?.id : null,
              }),
            ...(value.frequencyMonth === "frequencyDayOfMonths" && {
              scheduleMeetMonthFromDay: {
                dayOfMonth: value?.dayOfMonth,
                monthSpecificInterval: value?.intervalMonth,
              },
            }),
            ...(value.frequencyYear !== "periodMonths" &&
              value.frequency.id === "A" && {
                scheduleMeetYearFromWeekDay: {
                  indexWeekDay:
                    value?.periodYearsOrdinalNumber?.id ||
                    value?.ordinalNumber?.id,
                  intervalFirstDayOfWeek:
                    getDayIndex(value?.periodYearsDay?.id) ||
                    getDayIndex(value?.frequencyIntervalDay?.id),
                  monthSpecificInterval:
                    value?.qtdMonths || value?.intervalMonth,
                },
              }),
            ...(value.frequencyMonth === "frequencyIntervalOfMonths" &&
              value.frequency.id === "M" && {
                scheduleMeetMonthFromWeekDay: {
                  indexWeekDay:
                    value?.periodYearsOrdinalNumber?.id ||
                    value.ordinalNumber?.id,
                  intervalFirstDayOfWeek:
                    getDayIndex(value?.periodYearsDay?.id) ||
                    getDayIndex(value.frequencyIntervalDay?.id),
                  monthSpecificInterval:
                    value?.intervalMonth || value?.qtdMonths,
                },
              }),
            ...(value?.intervalWeek && {
              weekSpecificInterval: Number(value?.intervalWeek),
            }),
            ...(selectedDaysWeeklyFrequency && {
              daysOfWeek: selectedDaysWeeklyFrequency,
            }),
            ...(value?.periodYearsDay &&
              value?.frequencyYear === "periodYears" && {
                daysOfWeek: [getDayIndex(value?.periodYearsDay?.id)],
              }),
          },
        }),
        frequencyId: value?.frequency && value?.frequency?.id,
        attendees: membersAllParticipantsListSelected,
        ...(value?.endProgram?.id &&
          programEndDay && {
            numberOfOccurrences:
              value?.endProgram?.id !== 0 ? value?.endProgram?.id : null,
          }),
      },
    };

    const response = await updateMeeting(id, request);

    actionShowSpinner(false);

    if (response.error.length > 0) {
      setToastMessage({
        message: response.error,
        type: "error",
        open: true,
      });

      return;
    }

    history.push({
      pathname: "/meetings",
      state: { successUpdateMeet: true },
    });
  };

  const handleDelete = (memberDelSelected) => {
    const membersAllParticipantsListSelectedNew = [
      ...membersAllParticipantsListSelected,
    ];
    const idx = findIndex(membersAllParticipantsListSelectedNew, [
      "id",
      memberDelSelected.id,
    ]);
    membersAllParticipantsListSelectedNew.splice(idx, 1);
    setMembersAllParticipantsListSelected(
      membersAllParticipantsListSelectedNew
    );

    const membersAllParticipantsListNew = [...membersAllParticipantsList];
    membersAllParticipantsListNew.push(memberDelSelected);
    setMembersAllParticipantsList(membersAllParticipantsListNew);
  };

  const getParticipantsStatus = (idParticipants) => {
    const idx = findIndex(meeting.participants, ["id", idParticipants]);
    return idx === -1 ? "" : meeting.participants[idx].status;
  };

  const [meetingPartcipants, setMeetingPartcipants] = useState([]);

  useEffect(() => {
    async function load() {
      if (memberName?.length >= 3) {
        const res = await getMembersByName("pt", memberName);

        if (res.error?.length > 0) {
          setMeetingPartcipants([]);
        }

        const list = res.data.filter(
          (participant) =>
            !membersAllParticipantsListSelected
              .map((participant) => participant.id)
              .includes(participant.id)
        );

        setMeetingPartcipants(list);
      } else {
        setMeetingPartcipants([]);
      }
    }

    load();
  }, [memberName, membersList]);

  const [meetCancelDialogOpen, setMeetCancelDialogOpen] = useState(false);
  const [meetDeleteDialogOpen, setMeetDeleteDialogOpen] = useState(false);

  const handleOpenCancelMeetDialog = (event) => {
    setMeetCancelDialogOpen(true);
  };

  const handleCancelMeet = async () => {
    const cancelResponse = await cancelMeetingById(
      localStorage.getItem("i18nextLng"),
      id
    );

    if (cancelResponse.error.length > 0) {
      setToastMessage({
        message: "Ocorreu um erro ao tentar cancelar a reunião.",
        type: "error",
        open: true,
      });

      return;
    }

    setValue({ ...value, cancel: !value.cancel });
    setMeetCancelDialogOpen(false);

    history.push({
      pathname: "/meetings",
      state: { successCancelMeeting: true },
    });
  };

  const handleDeleteMeet = async () => {
    const cancelResponse = await deleteMeetingById(
      localStorage.getItem("i18nextLng"),
      id
    );

    if (cancelResponse.error.length > 0) {
      setToastMessage({
        message: "Ocorreu um erro ao tentar excluir a reunião.",
        type: "error",
        open: true,
      });

      return;
    }

    setValue({ ...value, cancel: !value.cancel });
    setMeetCancelDialogOpen(false);

    history.push({
      pathname: "/meetings",
      state: { successDeleteMeet: true },
    });
  };

  const [secretaryOptions, setSecretaryOptions] = useState([]);
  const [secretary, setSecretary] = useState();

  useEffect(() => {
    async function load() {
      if (secretary?.length >= 3) {
        const res = await getMembersByName("pt", secretary);

        if (res.error?.length > 0) {
          setSecretaryOptions([]);
        }

        setSecretaryOptions(res.data);
      } else {
        setSecretaryOptions([]);
      }
    }

    load();
  }, [secretary]);

  return (
    <Grid container className={classes.root}>
      {!detailMeet && (
        <DialogCustom
          open={meetCancelDialogOpen}
          handleClose={() => {
            setMeetCancelDialogOpen(false);
          }}
          handleChange={handleCancelMeet}
          title={t(`forms.dialog.alert`)}
          body={t("forms.dialog.textCancelMetting")}
          confirmText={t(`forms.dialog.yes`)}
          cancelText={t(`forms.dialog.no`)}
          alert={true}
        />
      )}

      {!detailMeet && (
        <DialogCustom
          open={meetDeleteDialogOpen}
          handleClose={() => {
            setMeetDeleteDialogOpen(false);
          }}
          handleChange={handleDeleteMeet}
          disabled={detailMeet}
          title={t(`forms.dialog.warning`)}
          body={t("forms.dialog.textDeleteMetting")}
          confirmText={t(`forms.dialog.yes`)}
          cancelText={t(`forms.dialog.no`)}
          error={true}
        />
      )}

      <Grid
        container
        item
        direction="row"
        justify="space-between"
        className={classes.spacer}
      >
        <Grid item md={6} lg={6}>
          <Typography variant="h4">
            {t(`meeting.${id && detailMeet ? "preview" : id ? "edit" : "new"}`)}
          </Typography>
        </Grid>
        {id && !detailMeet && (
          <Grid
            container
            item
            direction="row"
            md={6}
            lg={6}
            alignItems="center"
            justify="center"
          >
            <Grid item xs={6} md={6} lg={6}>
              <FormControlLabel
                control={
                  <Switch
                    id={value.cancel || false}
                    checked={value.cancel || false}
                    onChange={handleOpenCancelMeetDialog}
                    name="cancel"
                    color="primary"
                    disabled={!canCancelMeet}
                  />
                }
                label={t("meeting.cancel")}
              />
            </Grid>
            <Grid item>
              <IconButton
                disabled={!canDeleteMeet}
                onClick={() => setMeetDeleteDialogOpen(true)}
              >
                <CancelIcon className={classes.cancelIcon} />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography
                className={classes.iconText}
                onClick={() => {
                  if (canDeleteMeet) {
                    setMeetDeleteDialogOpen(true);
                  }
                }}
              >
                {t("meeting.delete")}
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>

      <Grid container direction="row" spacing={3}>
        <Grid item lg={8} xs={12}>
          <Paper elevation={1} className={classes.paper}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                className={classes.title}
                style={{ marginBottom: "0px" }}
              >
                {t("forms.committee.info")}
              </Typography>

              <FormControlLabel
                fullWidth
                control={
                  <Checkbox
                    disabled={true}
                    value={value.roundRobin}
                    checked={value.roundRobin}
                    onChange={() =>
                      setValue((oldValue) => ({
                        ...oldValue,
                        roundRobin: !oldValue.roundRobin,
                      }))
                    }
                    name="roundRobin"
                    id="roundRobin"
                    color="primary"
                  />
                }
                label={t("meeting.roundRobin")}
              />
            </div>

            <Grid container spacing={3}>
              <Grid item lg={6} xs={12}>
                <Select
                  disabled={detailMeet}
                  id="committee"
                  options={committeesListSelect}
                  value={value.committee}
                  setValue={(value) => {
                    handleChangeSelect(value, "committee");
                    manageCommitteeMembers(value);
                  }}
                  label={t("forms.committee.nameCommittee")}
                  error={value.committee ? false : true}
                  required={true}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <Select
                  id="secretary"
                  disabled={detailMeet}
                  options={secretaryOptions}
                  value={value.secretary}
                  required={true}
                  setValue={(value) => handleChangeSelect(value, "secretary")}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setSecretary(newInputValue);
                  }}
                  inputValue={secretary}
                  error={!value.secretary}
                  label={t("forms.committee.secretary")}
                />
              </Grid>
              <Grid item lg={6} xs={12}>
                <TextField
                  name="subject"
                  id="subject"
                  disabled={detailMeet}
                  onChange={handleChange}
                  value={value.subject || ""}
                  label={t("meeting.subject")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>
              <Grid item lg={3} xs={6}>
                <FormControlLabel
                  fullWidth
                  control={
                    <Checkbox
                      disabled={detailMeet}
                      value={value.onlineMeet}
                      checked={value.onlineMeet}
                      onChange={(event) => {
                        setValue({ ...value, onlineMeet: !value.onlineMeet });
                      }}
                      name="onlineMeet"
                      id="onlineMeet"
                      color="primary"
                    />
                  }
                  label={t("meeting.onlineMeet")}
                />
              </Grid>
              {!value.onlineMeet && (
                <Grid item lg={3} xs={12}>
                  <TextField
                    name="place"
                    id="place"
                    disabled={detailMeet}
                    onChange={handleChange}
                    value={value.place || ""}
                    label={t("meeting.place")}
                    fullWidth
                    autoComplete="nope"
                  />
                </Grid>
              )}
              <Grid item lg={6} xs={12}>
                <KeyboardDatePicker
                  autoOk
                  disableToolbar
                  variant="inline"
                  format={getInputDateFormats(i18n.language)}
                  id="date-picker-inline"
                  fullWidth
                  required
                  disabled={detailMeet}
                  label={t("meeting.meetingDate")}
                  value={selectedDate}
                  onChange={handleDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  error={selectedDate ? false : true}
                />
              </Grid>
              <Grid item lg={3} xs={6}>
                {!value.roundRobin && (
                  <InputMask
                    mask="99:99"
                    maskChar=""
                    name="startTime"
                    disabled={detailMeet || value.roundRobin}
                    onChange={handleChange}
                    required={!value.roundRobin}
                    value={value.startTime || ""}
                  >
                    {() => (
                      <TextField
                        fullWidth
                        name="startTime"
                        disabled={detailMeet}
                        onChange={handleChange}
                        value={value.startTime || ""}
                        inputProps={{
                          id: "startTime",
                        }}
                        label={t("meeting.startTime")}
                        error={value.startTime ? false : true}
                      />
                    )}
                  </InputMask>
                )}
              </Grid>
              <Grid item lg={3} xs={6}>
                {!value.roundRobin && (
                  <InputMask
                    mask="99:99"
                    maskChar=""
                    name="endTime"
                    disabled={detailMeet || value.roundRobin}
                    required={!value.roundRobin}
                    onChange={handleChange}
                    value={value.endTime || ""}
                  >
                    {() => (
                      <TextField
                        fullWidth
                        name="endTime"
                        onChange={handleChange}
                        disabled={detailMeet}
                        value={value.endTime || ""}
                        inputProps={{
                          id: "endTime",
                        }}
                        label={t("meeting.endTime")}
                        error={value.endTime ? false : true}
                      />
                    )}
                  </InputMask>
                )}
              </Grid>
              <Grid item lg={12} xs={12}>
                <TextField
                  name="comments"
                  id="comments"
                  onChange={handleChange}
                  disabled={detailMeet}
                  value={value.comments || ""}
                  label={t("meeting.comments")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>
              <Grid item lg={12} xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      value={value?.recurrence || false}
                      checked={value?.recurrence || false}
                      onChange={handleChangeCheckbox}
                      disabled={true}
                      name="recurrence"
                      id="recurrence"
                      color="primary"
                    />
                  }
                  label={t("meeting.recurrence")}
                />
              </Grid>
              {value.recurrence && (
                <>
                  <Grid item lg={4} xs={12}>
                    <Select
                      id="frequency"
                      options={frequencyMeeting}
                      value={value.frequency}
                      disabled={true}
                      setValue={(newValue) => {
                        setSelectedDaysWeeklyFrequency([]);
                        setValue({
                          ...value,
                          interval: "",
                          allDays: "",
                          intervalWeek: "",
                          intervalMonth: "",
                          ordinalNumber: "",
                          frequencyIntervalDay: "",
                          qtdMonths: "",
                          intervalYear: "",
                          frequencyYear: "periodMonths",
                          periodMonthsCount: "",
                          periodMonthSelected: "",
                          periodYearsOrdinalNumber: "",
                          periodYearsDay: "",
                          periodYearMonthSelected: "",
                          frequency: newValue,
                        });
                      }}
                      label={t("forms.committee.frequency")}
                    />
                  </Grid>
                  {value.frequency &&
                    value.frequency.id === "D" &&
                    !value.allDays && (
                      <Grid item lg={4} xs={12}>
                        <TextField
                          name="interval"
                          id="interval"
                          disabled={true}
                          onChange={handleChangeInterval}
                          value={value.interval || ""}
                          label={t("meeting.interval")}
                          fullWidth
                          required
                          autoComplete="nope"
                          error={!value.interval && !value.allDays}
                        />
                      </Grid>
                    )}
                  {value.frequency && value.frequency.id === "D" && (
                    <Grid item lg={4} xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={value.allDays || false}
                            checked={value.allDays || false}
                            onChange={handleChangeCheckbox}
                            name="allDays"
                            id="allDays"
                            disabled={true}
                            color="primary"
                          />
                        }
                        label={t("meeting.allDays")}
                      />
                    </Grid>
                  )}
                  {value.frequency && value.frequency.id === "S" && (
                    <Grid item lg={6} xs={12}>
                      <InputMask
                        mask="9999"
                        maskChar=""
                        onChange={handleChange}
                        value={value.intervalWeek || ""}
                        error={!value.intervalWeek}
                        disabled={true}
                      >
                        {() => (
                          <TextField
                            name="intervalWeek"
                            id="intervalWeek"
                            value={value.intervalWeek || ""}
                            error={!value.intervalWeek}
                            label={t("meeting.intervalWeek")}
                            onChange={handleChange}
                            fullWidth
                            disabled={true}
                            required
                            autoComplete="nope"
                          />
                        )}
                      </InputMask>
                    </Grid>
                  )}
                  {value.frequency && value.frequency.id === "S" && (
                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={
                        selectedDaysWeeklyFrequency?.length < 1
                          ? {
                              borderRadius: "8px",
                              border: "1px solid red",
                            }
                          : {}
                      }
                    >
                      <FormControl component="fieldset">
                        <FormLabel
                          component="legend"
                          style={
                            selectedDaysWeeklyFrequency?.length < 1
                              ? {
                                  marginBottom: 20,
                                  color: "red",
                                }
                              : {
                                  marginBottom: 20,
                                }
                          }
                        >
                          {t("forms.committee.daysOfWeek.title")}
                        </FormLabel>
                        <FormGroup>
                          {DAYSOFWEEKDEFAULT?.map((item) => (
                            <FormControlLabel
                              key={uniqueId()}
                              control={
                                <Checkbox
                                  disabled={true}
                                  color="primary"
                                  checked={selectedDaysWeeklyFrequency.includes(
                                    item.id
                                  )}
                                  onChange={(_event) => {
                                    if (
                                      selectedDaysWeeklyFrequency.includes(
                                        item.id
                                      )
                                    ) {
                                      const selectedDaysWithoutThis =
                                        selectedDaysWeeklyFrequency.filter(
                                          (day) => day !== item.id
                                        );

                                      setSelectedDaysWeeklyFrequency(
                                        selectedDaysWithoutThis
                                      );
                                    } else {
                                      setSelectedDaysWeeklyFrequency([
                                        ...selectedDaysWeeklyFrequency,
                                        item.id,
                                      ]);
                                    }
                                  }}
                                  name={item.name}
                                />
                              }
                              label={t(
                                `forms.committee.daysOfWeek.${item.name}`
                              )}
                            />
                          ))}
                        </FormGroup>

                        <span style={{ color: "red", fontSize: "16px" }}>
                          {selectedDaysWeeklyFrequency?.length < 1
                            ? "SELECIONE AO MENOS UM DIA DA SEMANA"
                            : ""}
                        </span>
                      </FormControl>
                    </Grid>
                  )}
                  {value.frequency && value.frequency.id === "M" && (
                    <Grid item lg={12} xs={12}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          disabled={true}
                          aria-label="frequencyMonth"
                          name="frequencyMonth"
                          value={value.frequencyMonth}
                          onChange={handleChange}
                          required={true}
                          row
                        >
                          <FormControlLabel
                            value="frequencyDayOfMonths"
                            control={<Radio size="small" />}
                            label={t("meeting.frequencyDayOfMonths")}
                          />
                          <FormControlLabel
                            value="frequencyIntervalOfMonths"
                            control={<Radio size="small" />}
                            label={t("meeting.frequencyIntervalOfMonths")}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  )}
                  {value.frequencyMonth &&
                    value.frequencyMonth === "frequencyDayOfMonths" &&
                    value.frequency &&
                    value.frequency.id === "M" && (
                      <>
                        <Grid item lg={4} xs={12}>
                          <TextField
                            disabled={true}
                            name="dayOfMonth"
                            id="dayOfMonth"
                            error={!value.dayOfMonth}
                            value={value.dayOfMonth || ""}
                            label={t("meeting.dayOfMonth")}
                            onChange={handleChange}
                            fullWidth
                            required
                            autoComplete="nope"
                          />
                        </Grid>
                        <Grid item lg={6} xs={12}>
                          <TextField
                            name="intervalMonth"
                            disabled={true}
                            id="intervalMonth"
                            error={!value.intervalMonth}
                            value={value.intervalMonth || ""}
                            label={t("meeting.intervalMonth")}
                            onChange={handleChange}
                            fullWidth
                            required
                            autoComplete="nope"
                          />
                        </Grid>
                      </>
                    )}
                  {value.frequencyMonth &&
                    value.frequencyMonth === "frequencyIntervalOfMonths" &&
                    value.frequency &&
                    value.frequency.id === "M" && (
                      <>
                        <Grid item lg={4} xs={12}>
                          <Select
                            id="ordinalNumber"
                            options={ordinalNumber}
                            disabled={true}
                            required
                            error={
                              !value.ordinalNumber && value.frequency.id === "M"
                            }
                            value={value.ordinalNumber}
                            setValue={(value) =>
                              handleChangeSelect(value, "ordinalNumber")
                            }
                            label={t("meeting.ordinalNumber")}
                          />
                        </Grid>
                        <Grid item lg={4} xs={12}>
                          <Select
                            id="frequencyIntervalDay"
                            options={days}
                            disabled={true}
                            required
                            error={!value.frequencyIntervalDay}
                            value={value.frequencyIntervalDay}
                            setValue={(value) =>
                              handleChangeSelect(value, "frequencyIntervalDay")
                            }
                            label={t("forms.committee.daysOfWeek.title")}
                          />
                        </Grid>
                        <Grid item lg={4} xs={12}>
                          <TextField
                            name="qtdMonths"
                            id="qtdMonths"
                            error={!value.qtdMonths}
                            disabled={true}
                            value={value.qtdMonths || ""}
                            label={t("meeting.qtdMonths")}
                            onChange={handleChange}
                            fullWidth
                            required
                            autoComplete="nope"
                          />
                        </Grid>
                      </>
                    )}
                  {value.frequency && value.frequency.id === "A" && (
                    <Grid item lg={4} xs={12}>
                      <TextField
                        name="intervalYear"
                        id="intervalYear"
                        disabled={true}
                        value={value.intervalYear || ""}
                        label={t("meeting.intervalYear")}
                        onChange={handleChange}
                        fullWidth
                        error={
                          value.frequency.id === "A" && !value.intervalYear
                        }
                        required
                        autoComplete="nope"
                      />
                    </Grid>
                  )}
                  {value.frequency && value.frequency.id === "A" && (
                    <Grid item lg={4} xs={12}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          disabled={true}
                          aria-label="frequencyYear"
                          name="frequencyYear"
                          value={value.frequencyYear}
                          onChange={handleChange}
                          required={true}
                          row
                        >
                          <FormControlLabel
                            value="periodMonths"
                            control={<Radio size="small" />}
                            label={t("meeting.periodMonths")}
                          />
                          <FormControlLabel
                            value="periodYears"
                            control={<Radio size="small" />}
                            label={t("meeting.periodYears")}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  )}
                  {value.frequency &&
                    value.frequency.id === "A" &&
                    value.frequencyYear &&
                    value.frequencyYear === "periodMonths" && (
                      <>
                        <Grid item lg={4} xs={12}>
                          <TextField
                            disabled={true}
                            name="periodMonthsCount"
                            id="periodMonthsCount"
                            value={value.periodMonthsCount || ""}
                            label={t("meeting.periodMonthsCount")}
                            error={!value.periodMonthsCount}
                            onChange={handleChange}
                            fullWidth
                            required
                            autoComplete="nope"
                          />
                        </Grid>
                      </>
                    )}
                  {value.frequency &&
                    value.frequency.id === "A" &&
                    value.frequencyYear &&
                    value.frequencyYear === "periodYears" && (
                      <>
                        <Grid item lg={4} xs={12}>
                          <Select
                            disabled={true}
                            id="periodYearsOrdinalNumber"
                            options={ordinalNumber}
                            required
                            value={value.periodYearsOrdinalNumber}
                            error={
                              !value.periodYearsOrdinalNumber &&
                              value.frequency.id === "A"
                            }
                            setValue={(value) =>
                              handleChangeSelect(
                                value,
                                "periodYearsOrdinalNumber"
                              )
                            }
                            label={t("meeting.ordinalNumber")}
                          />
                        </Grid>
                        <Grid item lg={4} xs={12}>
                          <Select
                            id="periodYearsDay"
                            disabled={true}
                            options={days}
                            value={value.periodYearsDay}
                            required
                            error={
                              !value.periodYearsDay &&
                              value.frequency.id === "A"
                            }
                            setValue={(value) =>
                              handleChangeSelect(value, "periodYearsDay")
                            }
                            label={t("forms.committee.daysOfWeek.title")}
                          />
                        </Grid>
                      </>
                    )}
                  {value.frequency && value.frequency.id === "A" && (
                    <Grid item lg={4}>
                      <Select
                        id="periodYearMonthSelected"
                        options={months}
                        disabled={true}
                        value={value.periodYearMonthSelected}
                        required
                        error={!value.periodYearMonthSelected}
                        setValue={(value) =>
                          handleChangeSelect(value, "periodYearMonthSelected")
                        }
                        label={t("forms.committee.month")}
                      />
                    </Grid>
                  )}

                  <Grid item lg={6} xs={12}>
                    <KeyboardDatePicker
                      autoOk
                      disableToolbar
                      variant="inline"
                      format={getInputDateFormats(i18n.language)}
                      id="startDate"
                      disabled={true}
                      fullWidth
                      label={t("meeting.startDate")}
                      value={selectedStartDate}
                      onChange={handleStartDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </Grid>

                  <Grid item lg={4} xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          value={programEndDay}
                          checked={programEndDay}
                          onChange={() => setProgramEndDay(!programEndDay)}
                          name="programEndDay"
                          id="programEndDay"
                          disabled={true}
                          color="primary"
                        />
                      }
                      label="Programar encerramento"
                    />
                  </Grid>

                  {programEndDay ? (
                    <Grid item lg={6} xs={12}>
                      <Select
                        id="endProgram"
                        options={endAfter}
                        value={value.endProgram}
                        error={!value.endProgram}
                        disabled={true}
                        setValue={(value) =>
                          handleChangeSelect(value, "endProgram")
                        }
                        label={t("meeting.endProgram")}
                      />
                    </Grid>
                  ) : (
                    <Grid item lg={6} xs={12}>
                      <KeyboardDatePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format={getInputDateFormats(i18n.language)}
                        disabled={true}
                        id="endDate"
                        fullWidth
                        label={t("meeting.endDate")}
                        value={selectedEndDate}
                        onChange={handleEndDateChange}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </Paper>
        </Grid>
        <Grid item lg={4} xs={12}>
          <Paper elevation={1} className={classes.paper}>
            <Typography className={classes.title}>
              {t("meeting.participants")}
            </Typography>
            <Grid container spacing={3} className={classes.spacer}>
              <Grid item xs={10} md={12} lg={12}>
                <Select
                  id="participants"
                  disabled={detailMeet}
                  options={meetingPartcipants}
                  value={value.participants}
                  setValue={(value) => {
                    if (
                      membersAllParticipantsListSelected.some(
                        (participant) => participant.id === value.id
                      )
                    ) {
                      setToastMessage({
                        message:
                          "Esse usuário já pertence a lista de participantes.",
                        type: "error",
                        open: true,
                      });

                      return;
                    }

                    if (value) {
                      setMembersAllParticipantsListSelected([
                        ...membersAllParticipantsListSelected,
                        value,
                      ]);
                    }

                    handleChangeSelect(value, "participants");
                  }}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setMemberName(newInputValue);
                  }}
                  inputValue={memberName}
                  label={t("name")}
                />
              </Grid>
              {membersAllParticipantsListSelected?.map((item, index) => (
                <Grid item xs={12} key={item?.id}>
                  <WrapperChip status={getParticipantsStatus(item?.id)}>
                    <Chip
                      disabled={detailMeet}
                      clickable={false}
                      icon={
                        item.isCommitteeMember ? (
                          <MdGroups style={{ fontSize: "1rem" }} />
                        ) : (
                          <Face />
                        )
                      }
                      label={item?.isExternal ? `${item.name} (Externo)` : item?.name}
                      onDelete={() => handleDelete(item)}
                      color="primary"
                      style={item?.isExternal ? { borderStyle: "dashed" } : {}}
                    />
                  </WrapperChip>
                </Grid>
              ))}
            </Grid>
            {id && (
              <Grid container item direction="column" spacing={2}>
                <Grid container item direction="row">
                  <Circle status="CONFIRM" />
                  <Typography component="body1" variant="body1">
                    {t("meeting.confirm")}
                  </Typography>
                </Grid>
                <Grid container item direction="row">
                  <Circle status="MAYBE" />
                  <Typography component="body1" variant="body1">
                    {t("meeting.maybe")}
                  </Typography>
                </Grid>
                <Grid container item direction="row">
                  <Circle status="EMPTY" />
                  <Typography component="body1" variant="body1">
                    {t("meeting.empty")}
                  </Typography>
                </Grid>
                <Grid container item direction="row">
                  <Circle status="REFUSE" />
                  <Typography component="body1" variant="body1">
                    {t("meeting.refuse")}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Paper>
        </Grid>
      </Grid>

      {!detailMeet && (
        <Grid container item direction="row" justify="center" spacing={2}>
          <Grid item>
            <Button
              variant="outlined"
              className={classes.buttonOutlined}
              onClick={() => history.push("/meetings")}
            >
              {t("cancel")}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              className={classes.button}
              onClick={handleSave}
              disabled={!canUpdateMeet}
            >
              {t("meeting.saveMeeting")}
            </Button>
          </Grid>
        </Grid>
      )}

      <ToastMessage
        message={toastMessage.message}
        type={toastMessage.type || "error"}
        open={toastMessage.open}
        close={() => setToastMessage({ ...toastMessage, open: false })}
      />
    </Grid>
  );
};

const withRouterFormSlot = withRouter(FormMeetingEdit);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const FormSlotConnect = connect(null, mapDispatchToProps)(withRouterFormSlot);

export default withTranslation()(FormSlotConnect);
